var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrustpilotStarHalf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6619 0H18.1619V35H35.6619V0Z",
    fill: "#DCDCE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1604 0H0.6604V35H18.1604V0Z",
    fill: "#00B67A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.167 23.5876L23.4899 22.2386L25.7139 29.0928L18.167 23.5876ZM30.417 14.7282H21.0472L18.167 5.90527L15.2868 14.7282H5.91699L13.5003 20.1969L10.6201 29.0199L18.2035 23.5511L22.8701 20.1969L30.417 14.7282Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotStarHalf);
export default __webpack_public_path__ + "static/media/trustpilot-star-half.ff5016b637ece4e02aaf28824a2224e3.svg";
export { ForwardRef as ReactComponent };